import { createChildPath } from '../../../utils';
import generateAsyncRouteComponent from '../../../generateAsyncRouteComponent';

export default {
  path: createChildPath('personal'),
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/PersonalContainer'),
  }),
};
